<template>
  <div>
    <CRow>
      <CCol sm="12">
        <QuestionsTable
          :items="questions"
          special="0"
          hover
          striped
          border
          small
          fixed
          caption="Configuración de Preguntas Predeterminadas"
          @refresh="refreshItems"
          @storeModal="storeModal"
          @updateModal="updateModal"
          @deleteModal="deleteModal"
          @reorder="loadQuestions"
          :tableFilter="{label: 'Buscar: ', placeholder: ' '}"
        />

      </CCol>
    </CRow>

    <QuestionModal ref="questionModal" :questions="questions" @store="storeProcess" @update="updateProcess"></QuestionModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </div>
</template>

<script>
import QuestionsTable from '../../components/questions/QuestionsTable.vue'
import QuestionModal from '../../components/questions/QuestionModal.vue'
import DeleteModal from '../../components/global/DeleteModal.vue'

import ws from '../../services/questions';
import store from '../../store'

export default {
  name: 'Questions',
  components: { QuestionsTable, QuestionModal, DeleteModal },
  data: function () {
		return {
            special: 0,
            questions: []
        }
  },
  mounted: async function() {
    this.loading();
    await this.loadQuestions();
    this.loaded();
  },
  methods: {
    async loadQuestions() {
      const response = await ws.get();
      const specialResponse = await ws.getSpecial();
      const questions = response.type == "success" ? response.data : [];
      const specialQuestions = specialResponse.type == "success" ? specialResponse.data : [];

      this.questions = questions.concat(specialQuestions).sort((first, second) => first.position - second.position);
    },
    storeModal () {
      this.$refs.questionModal.storeModal();
    },
    updateModal (special, item) {
      this.$refs.questionModal.updateModal(special, item);
    },
    deleteModal (special, item) {
      this.$refs.deleteModal.show("Eliminar Pregunta", item.id, item.name);

      this.special = item.is_special+"";
    },
    async refreshItems (items){
      this.loading();
      this.questions = await items;
      this.loaded();
    },
    async storeProcess(data){
      this.loading();
      let response = await ws.store(data);

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    async updateProcess(data){
      this.loading();
      let response = await ws.update(data);

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    async deleteProcess(data){
      this.loading();
      let response = await ws.delete(data);

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
